'use client';

import BaseModal from '@c/modals/BaseModal';
import { ProductDocument, Variation } from 'models/product';
import { StepType } from '../types';
import { Montserrat } from 'next/font/google';
import { MakeAnOfferForm } from '../forms/MakeAnOfferForm';

const montserrat = Montserrat({
  subsets: ['latin'],
  weight: ['400', '500', '600', '700'],
});

interface DesktopMakeAnOfferModalProps {
  isOpen: boolean;
  dismiss: () => void;
  product: ProductDocument;
  selectedVariations: Variation[] | null;
  stepData: {
    steps: StepType[];
    totalSteps: number;
  };
  navigationBar: React.ReactNode;
  activeStep: number;
  setActiveStep: (step: number) => void;
}

export default function DesktopMakeAnOfferModal({
  isOpen,
  dismiss,
  product,
  selectedVariations,
  stepData,
  navigationBar,
  activeStep,
  setActiveStep,
}: DesktopMakeAnOfferModalProps) {
  const { steps, totalSteps } = stepData;
  const shouldShowBackArrow = activeStep > 0;

  const handleBackArrow = () => {
    setActiveStep(activeStep - 1);
  };
  return (
    <BaseModal
      isOpen={isOpen}
      dismiss={dismiss}
      title={`Make An Offer`}
      onBackButtonClick={shouldShowBackArrow ? handleBackArrow : undefined}
    >
      <div
        className={`flex h-[78rem] w-full flex-col sm:w-[55rem] ${montserrat.className}`}
      >
        {navigationBar}

        <div className="flex h-full w-full justify-center p-4 sm:p-8">
          <MakeAnOfferForm
            product={product}
            selectedVariations={selectedVariations}
            dismiss={dismiss}
            currentStep={activeStep}
            setCurrentStep={setActiveStep}
            stepList={steps}
          />
        </div>
      </div>
    </BaseModal>
  );
}
